import React from 'react';

export default function MapPage() {
  return (
    <h1>MapPage</h1>
  );
}